/** Herbicide product-type names are localized (es/pt "Herbicida", en "Herbicide"). */
export const isHerbicideTypeName = (name: string): boolean => /herbici/i.test(name);

/**
 * Fungicide/insecticide product-type names, localized: es "Fungicida"/"Insecticida",
 * en "Fungicide"/"Insecticide", pt "Fungicida"/"Inseticida".
 */
export const isFungicideOrInsecticideTypeName = (name: string): boolean => /fungicid|insectic|insetic/i.test(name);
